import { render } from "./contract.vue?vue&type=template&id=d37e986e&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"

import "./contract.vue?vue&type=style&index=0&id=d37e986e&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1ac9e6a1-3d63-42f4-aa32-2a0557ce8f53/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d37e986e"]])

export default __exports__